export const PCBA_EMPTY = { category: "SMT", sku_part_code: "", zti_part_code: "", item_name: "", bom_description: "", observed_part_code: "", observed_description: "", checks: [] };
export const PCBA_KEYS = ["category", "sku_part_code", "zti_part_code", "item_name", "bom_description", "observed_part_code", "observed_description"];

const Sec = ({ title, children }) => <div className="pp-card p-3 space-y-2"><div className="pp-label text-blue-700">{title}</div><div className="grid grid-cols-2 md:grid-cols-4 gap-3">{children}</div></div>;

export function PcbaFields({ f, setF }) {
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const I = (label, k, cls = "") => <label className={`block ${cls}`}><span className="pp-label block mb-1">{label}</span><input className="pp-input w-full" value={f[k] ?? ""} onChange={set(k)} data-testid={`q-${k}`} /></label>;
  return (
    <>
      <Sec title="Standard specification (fill as per BOM)">
        <label className="block"><span className="pp-label block mb-1">Category</span><select className="pp-select w-full" value={f.category || ""} onChange={set("category")} data-testid="q-category">{["SMT", "MI", "BLT", "FATP"].map((x) => <option key={x}>{x}</option>)}</select></label>
        {I("SKU part code", "sku_part_code")}{I("ZTI part code", "zti_part_code")}{I("Item name", "item_name")}{I("BOM description", "bom_description", "col-span-2 md:col-span-4")}
      </Sec>
      <Sec title="Observation">
        {I("Observed part code", "observed_part_code", "col-span-2")}{I("Observed description", "observed_description", "col-span-2")}
      </Sec>
    </>
  );
}
